import ShopArticleTaxListResultModelBase from '../_generated/modelBases/shop-article-tax-list-result-model-base';

export default class ShopArticleTaxListResultModel extends ShopArticleTaxListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
